module.exports = __webpack_public_path__ + "img/pause.9510fabb.png";